/* esm.sh - highlight.js@11.11.1/lib/languages/plaintext */
function e(t){return{name:"Plain text",aliases:["text","txt"],disableAutodetect:!0}}export{e as default};
//# sourceMappingURL=plaintext.mjs.map